import axios from "axios";
import EventBus from "@/utils/global-events.js";
import { loadStripeTerminal } from "@stripe/terminal-js/pure";

export default {
  strict: true,
  namespaced: true,
  state: {
    terminal: {},
    reader: {},
    readers: [],
    connectionStatus: null,
  },
  getters: {
    terminal: (state) => state.terminal,
    readers: (state) => state.readers,
    reader: (state) => state.reader,
    connectionStatus: (state) => state.connectionStatus,
  },
  mutations: {
    setTerminal(state, payload) {
      state.terminal = payload;
    },
    setReaders(state, payload) {
      state.readers = payload;
    },
    setReader(state, payload) {
      state.reader = payload;
      if (payload !== null) localStorage.setItem("terminal/reader", payload.id);
    },
    setConnectionStatus(state, payload) {
      state.connectionStatus = payload;
    },
  },
  actions: {
    init: async ({ commit, rootState }) => {
      const STRIPE_TERMINAL = await loadStripeTerminal();

      commit("setConnectionStatus", "Not Connected");
      const currentOrg = rootState.organization.organization;
      let stripeTerminal = null;
      let savedReaderId = localStorage.getItem("terminal/reader");

      if (currentOrg && currentOrg.type === "business" && savedReaderId != null) {
        commit("setConnectionStatus", "Connecting...");
        stripeTerminal = STRIPE_TERMINAL.create({
          onFetchConnectionToken: function () {
            return axios.post(`/businesses/${currentOrg.id}/tokens`).then((res) => {
              return res.data.clientSecret;
            });
          },
          onUnexpectedReaderDisconnect: function () {
            EventBus.$emit("GLOBAL_NOTIFY", { title: "Card Reader Disconnected", message: "Your Card Reader was disconnected" });
            commit("setTerminal", null);
            commit("setReader", null);
            commit("setConnectionStatus", "Disconnected");
          },
        });

        const config = { simulated: false };
        const discoverResult = await stripeTerminal.discoverReaders(config);

        if (discoverResult.error) {
          console.log("Failed to discover: ", discoverResult.error);
          commit("setConnectionStatus", "Not Connected");
          commit("setReaders", []);
          return;
        } else if (discoverResult.discoveredReaders.length === 0) {
          console.log("No available readers.");
          commit("setReaders", []);
          commit("setConnectionStatus", "Not Connected");
          return;
        } else {
          var readers = discoverResult.discoveredReaders;
          commit("setReaders", discoverResult.discoveredReaders);
        }

        for (var i = 0; i < readers.length; i++) {
          if (readers[i].id === savedReaderId) {
            const connectResult = await stripeTerminal.connectReader(readers[i]);
            if (connectResult.error) {
              console.log("Reader Connect Error on Init: " + connectResult.error);
              commit("setConnectionStatus", "Not Connected");
            } else {
              commit("setTerminal", stripeTerminal);
              commit("setReader", readers[i]);
              commit("setConnectionStatus", "Connected");
            }
          }
        }
      }
      if (currentOrg && currentOrg.type !== "business") {
        commit("setTerminal", null);
        commit("setReaders", []);
        commit("setReader", null);
        commit("setConnectionStatus", "Not Connected");
      }
    },
    updateTerminal: (context, payload) => context.commit("setTerminal", payload),
    updateReader: (context, payload) => context.commit("setReader", payload),
    updateConnectionStatus: (context, payload) => context.commit("setConnectionStatus", payload),
  },
};
